/**
 * @file：医院 request
 */

import { request } from './request';
import { ApiConfigs, Response } from '../schemas/service';

const api: ApiConfigs = {
  queryHospitals: {
    url: '/health/api/v1/hospital/hospitalInformationByPage',
    method: 'GET'
  },
  queryFirstDepartment: {
    // url:
    // 'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/hospital/queryFirstDepartment',
    url: '/health/api/v1/hospital/queryFirstDepartment',
    method: 'GET'
  },
  querySecondDepartment: {
    // url:
    //   'https://kapi.corp.kuaishou.com/mock/5058/health/api/v1/hospital/querySecondDepartment',
    url: '/health/api/v1/hospital/querySecondDepartment',
    method: 'GET'
  }
};

const hospitals = {
  async getHospitals({ pageNum = 1, pageSize = 10 }) {
    const response: Response = await request(api.queryHospitals, {
      pageNum,
      pageSize
    });
    const { result } = response;
    return result;
  },

  async getHospitalFirstDepartment({ hospitalIndexId }) {
    // console.log(`hospitalIndexId ${hospitalIndexId}`);
    const response: Response = await request(api.queryFirstDepartment, {
      hospitalIndexId
    });
    const { result } = response;
    return result as IQueryDepartment[];
  },

  async getHospitalSecondDepartment({ hospitalIndexId, firstDepartmentCode }) {
    const response: Response = await request(api.querySecondDepartment, {
      hospitalIndexId,
      firstDepartmentCode
    });
    const { result } = response;
    return result as IQueryDepartment[];
  }
};

export interface IQueryDepartment {
  departmentCode?: string;
  departmentGoodProject?: string;
  departmentInfo?: string;
  departmentName?: string;
  hospitalIndexId?: number;
  serialNum?: string;
}

export default hospitals;
